(function () {
  var INTERVAL = 5000;
  var MOBILE_INTERVAL = 4500;
  var DESKTOP = '(min-width: 992px)';
  var boundGalleries = [];

  function isDesktop() {
    return window.matchMedia(DESKTOP).matches;
  }

  function reducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function afterTheme(fn) {
    window.setTimeout(fn, 0);
  }

  function mediaIdOf(el) {
    if (!el) return '';
    var node = el.hasAttribute('data-media-id')
      ? el
      : el.querySelector('[data-media-id], [data-media-thumb-id]');
    return node
      ? String(node.getAttribute('data-media-id') || node.getAttribute('data-media-thumb-id') || '')
      : '';
  }

  function getSlides(area) {
    return Array.prototype.slice.call(area.querySelectorAll('.theme-images > .theme-img'));
  }

  function visibleSlides(area) {
    var vis = getSlides(area).filter(function (s) {
      return s.getAttribute('aria-hidden') !== 'true';
    });
    return vis.length ? vis : getSlides(area);
  }

  function bindVariant(gallery, onSelect) {
    if (!gallery || !window.jQuery) return;
    if (boundGalleries.indexOf(gallery) > -1) return;
    boundGalleries.push(gallery);
    window.jQuery(gallery).on('variantImageSelected.foGallery', function (e, variant) {
      afterTheme(function () {
        onSelect(variant);
      });
    });
  }

  function initDesktop(force) {
    if (!isDesktop()) return;

    var area = document.querySelector(
      '.template-product .product-area.product-area--one-col'
    );
    if (!area) return;
    if (area.dataset.foGalleryInit === '1' && !force) return;
    if (force && area._foGalleryStop) area._foGalleryStop();

    var thumbs = Array.prototype.slice.call(
      area.querySelectorAll('.product-area__thumbs__thumb')
    );
    if (!getSlides(area).length) return;

    area.dataset.foGalleryInit = '1';
    area.classList.add('fo-gallery-carousel');
    area.classList.remove('fo-gallery-fallback');

    var gallery = area.querySelector('.theme-gallery');
    var swiperEl = area.querySelector('.product-area__media .swiper-container');
    if (swiperEl && swiperEl.swiper) {
      try {
        swiperEl.swiper.destroy(true, true);
      } catch (err) {}
    }

    function resetMargin() {
      if (!gallery) return;
      if (gallery.style.marginTop === '0px' && gallery.style.getPropertyPriority('margin-top') === 'important') {
        return;
      }
      gallery.style.setProperty('margin-top', '0', 'important');
    }
    resetMargin();
    if (gallery && !gallery._foPinMo) {
      gallery._foPinMo = new MutationObserver(resetMargin);
      gallery._foPinMo.observe(gallery, { attributes: true, attributeFilter: ['style'] });
    }

    var progress = area.querySelector('.fo-gallery-progress');
    if (!progress) {
      progress = document.createElement('div');
      progress.className = 'fo-gallery-progress';
      progress.setAttribute('aria-hidden', 'true');
      progress.innerHTML = '<span class="fo-gallery-progress__bar"></span>';
      if (gallery && gallery.parentNode) {
        gallery.parentNode.insertBefore(progress, gallery.nextSibling);
      }
    }
    var bar = progress.querySelector('.fo-gallery-progress__bar');

    var index = 0;
    var timer = null;
    var paused = false;

    function restartProgress() {
      var vis = visibleSlides(area);
      if (!bar || vis.length < 2) {
        progress.style.display = 'none';
        return;
      }
      progress.style.display = '';
      bar.classList.remove('is-running');
      bar.style.animationDuration = INTERVAL + 'ms';
      void bar.offsetWidth;
      if (!paused) bar.classList.add('is-running');
    }

    function show(i, mediaId) {
      var vis = visibleSlides(area);
      if (mediaId) {
        var found = vis.findIndex(function (s) {
          return mediaIdOf(s) === String(mediaId);
        });
        if (found > -1) i = found;
      }
      if (!vis.length) return;
      index = ((i % vis.length) + vis.length) % vis.length;
      getSlides(area).forEach(function (slide) {
        slide.classList.remove('fo-slide-active', 'current-img');
      });
      vis[index].classList.add('fo-slide-active');
      var activeId = mediaIdOf(vis[index]);
      thumbs.forEach(function (thumb) {
        var on = mediaIdOf(thumb) === activeId && thumb.getAttribute('data-cc-hidden') !== 'true';
        var link = thumb.querySelector('a');
        if (link) link.classList.toggle('thumb-active', on);
      });
      restartProgress();
    }

    function next() {
      show(index + 1);
    }

    function stop() {
      paused = true;
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      if (bar) bar.classList.remove('is-running');
    }

    function start() {
      stop();
      paused = false;
      if (visibleSlides(area).length < 2) return;
      if (reducedMotion()) return;
      restartProgress();
      timer = setInterval(next, INTERVAL);
    }

    if (!area.dataset.foGalleryClicks) {
      area.dataset.foGalleryClicks = '1';
      area.addEventListener(
        'click',
        function (e) {
          var link = e.target.closest('.product-area__thumbs__thumb a');
          if (!link || !area.contains(link)) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          var thumb = link.closest('.product-area__thumbs__thumb');
          paused = false;
          show(0, mediaIdOf(thumb));
          start();
        },
        true
      );

      var media = area.querySelector('.product-area__media');
      if (media) {
        media.addEventListener('mouseenter', stop);
        media.addEventListener('mouseleave', start);
        media.addEventListener('focusin', stop);
        media.addEventListener('focusout', start);
      }
    }

    bindVariant(gallery, function (variant) {
      var mid = variant && variant.featured_media && variant.featured_media.id;
      show(0, mid);
      start();
    });

    if (!area._foGalleryMo) {
      var wrap = area.querySelector('.theme-images');
      if (wrap) {
        var moTimer;
        area._foGalleryMo = new MutationObserver(function () {
          clearTimeout(moTimer);
          moTimer = setTimeout(function () {
            show(index);
            start();
          }, 40);
        });
        area._foGalleryMo.observe(wrap, {
          attributes: true,
          subtree: true,
          attributeFilter: ['aria-hidden']
        });
      }
    }

    var current = area.querySelector('.theme-img.current-img:not([aria-hidden="true"])');
    show(0, current ? mediaIdOf(current) : '');
    start();

    area._foGalleryStop = stop;
    area._foGalleryStart = start;
    area._foGalleryShow = show;
  }

  function runOverlayAutoplay(area) {
    var thumbs = Array.prototype.slice.call(
      area.querySelectorAll('.product-area__thumbs__thumb')
    );
    var index = 0;
    var timer = null;
    var delay = reducedMotion() ? 7000 : MOBILE_INTERVAL;

    function show(i, mediaId) {
      var vis = visibleSlides(area);
      if (mediaId) {
        var found = vis.findIndex(function (s) {
          return mediaIdOf(s) === String(mediaId);
        });
        if (found > -1) i = found;
      }
      if (!vis.length) return;
      index = ((i % vis.length) + vis.length) % vis.length;
      getSlides(area).forEach(function (slide) {
        slide.classList.remove('fo-slide-active', 'current-img');
      });
      vis[index].classList.add('fo-slide-active');
      var activeId = mediaIdOf(vis[index]);
      thumbs.forEach(function (thumb) {
        var on = mediaIdOf(thumb) === activeId && thumb.getAttribute('data-cc-hidden') !== 'true';
        thumb.classList.toggle('is-active', on);
        var link = thumb.querySelector('a');
        if (link) link.classList.toggle('thumb-active', on);
      });
    }

    function play() {
      if (timer) clearInterval(timer);
      if (visibleSlides(area).length < 2) return;
      timer = setInterval(function () {
        show(index + 1);
      }, delay);
    }

    if (!area.dataset.foGalleryClicks) {
      area.dataset.foGalleryClicks = '1';
      thumbs.forEach(function (thumb) {
        thumb.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            show(0, mediaIdOf(thumb));
            play();
          },
          true
        );
      });
    }

    var current = area.querySelector('.theme-img.current-img:not([aria-hidden="true"])');
    show(0, current ? mediaIdOf(current) : '');
    play();
    area._foGalleryShow = show;
    area._foGalleryStart = play;
  }

  function initMobile(attempt, force) {
    if (isDesktop()) return;

    var area = document.querySelector('.template-product .product-area');
    if (!area) return;
    if (area.dataset.foMobileGallery === '1' && !force) return;

    var container = area.querySelector('.product-area__media .swiper-container');
    var swiper = container && container.swiper;
    if (!swiper) {
      if ((attempt || 0) < 20) {
        setTimeout(function () {
          initMobile((attempt || 0) + 1, force);
        }, 150);
        return;
      }
      area.dataset.foMobileGallery = '1';
      area.classList.add('fo-gallery-fallback');
      runOverlayAutoplay(area);
      bindVariant(area.querySelector('.theme-gallery'), function (variant) {
        var mid = variant && variant.featured_media && variant.featured_media.id;
        if (area._foGalleryShow) area._foGalleryShow(0, mid);
        if (area._foGalleryStart) area._foGalleryStart();
      });
      return;
    }

    area.dataset.foMobileGallery = '1';
    area.classList.add('fo-pdp-mobile');
    area.classList.remove('fo-gallery-fallback');

    var thumbs = Array.prototype.slice.call(
      area.querySelectorAll('.product-area__thumbs__thumb')
    );
    var delay = reducedMotion() ? 7000 : MOBILE_INTERVAL;
    var timer = null;

    function advance() {
      var last = swiper.slides.length - 1;
      if (last < 1) return;
      swiper.slideTo(swiper.activeIndex >= last ? 0 : swiper.activeIndex + 1);
    }

    function play() {
      if (timer) clearInterval(timer);
      if (!swiper.slides || swiper.slides.length < 2) return;
      timer = setInterval(advance, delay);
    }

    function sync() {
      var active = swiper.slides[swiper.activeIndex];
      var mid = mediaIdOf(active);
      thumbs.forEach(function (thumb) {
        var on = mediaIdOf(thumb) === mid && thumb.getAttribute('data-cc-hidden') !== 'true';
        thumb.classList.toggle('is-active', on);
        var link = thumb.querySelector('a');
        if (link) link.classList.toggle('thumb-active', on);
      });
    }

    play();
    swiper.on('touchEnd', play);

    if (!area.dataset.foGalleryClicks) {
      area.dataset.foGalleryClicks = '1';
      thumbs.forEach(function (thumb) {
        thumb.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            e.stopImmediatePropagation();
            var mid = mediaIdOf(thumb);
            var i = 0;
            Array.prototype.forEach.call(swiper.slides, function (slide, n) {
              if (mediaIdOf(slide) === mid) i = n;
            });
            swiper.slideTo(i);
            sync();
            play();
          },
          true
        );
      });
    }

    swiper.on('slideChange', sync);
    sync();

    bindVariant(area.querySelector('.theme-gallery'), function (variant) {
      var mid = variant && variant.featured_media && variant.featured_media.id;
      try {
        swiper.update();
      } catch (err) {}
      var i = 0;
      Array.prototype.forEach.call(swiper.slides, function (slide, n) {
        if (String(mediaIdOf(slide)) === String(mid)) i = n;
      });
      swiper.slideTo(i, 0);
      sync();
      play();
    });
  }

  function initStickyPrice() {
    var target = document.querySelector('[data-fo-sticky-price]');
    var source = document.querySelector('.product-area__details .price-area');
    if (!target || !source || target.dataset.foStickyInit === '1') return;
    target.dataset.foStickyInit = '1';

    function copy() {
      var html = source.innerHTML.trim();
      if (html) target.innerHTML = html;
    }

    copy();
    new MutationObserver(copy).observe(source, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function bindEarly() {
    var gallery = document.querySelector('.template-product .theme-gallery');
    if (!gallery || !window.jQuery) return;
    bindVariant(gallery, function (variant) {
      var area = document.querySelector('.template-product .product-area');
      if (!area) return;
      var mid = variant && variant.featured_media && variant.featured_media.id;
      if (isDesktop()) {
        initDesktop();
        if (area._foGalleryShow) area._foGalleryShow(0, mid);
        if (area._foGalleryStart) area._foGalleryStart();
      } else if (area._foGalleryShow) {
        area._foGalleryShow(0, mid);
        if (area._foGalleryStart) area._foGalleryStart();
      }
    });
  }

  function boot(force) {
    if (force) {
      var area = document.querySelector('.template-product .product-area');
      if (area) {
        delete area.dataset.foGalleryInit;
        delete area.dataset.foMobileGallery;
        if (area._foGalleryStop) area._foGalleryStop();
      }
    }
    bindEarly();
    initDesktop(force);
    initMobile(0, force);
    initStickyPrice();
  }

  bindEarly();
  // theme.js inits the gallery on jQuery ready (after this deferred file runs).
  // Booting now lets thumbnails set margin-top: -Npx and yank the photos off-screen.
  function bootAfterTheme() {
    boot(true);
    if (window.jQuery) {
      window.jQuery(window).off('resize.thumbHeight debouncedresizewidth.thumbHeight');
    }
  }
  if (window.jQuery) {
    window.jQuery(bootAfterTheme);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(false);
    });
  } else {
    boot(false);
  }

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) boot(true);
  });

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      var area = document.querySelector('.template-product .product-area');
      if (!area) return;
      if (isDesktop()) {
        if (area.dataset.foGalleryInit === '1') {
          if (area._foGalleryStart) area._foGalleryStart();
        } else {
          if (area._foGalleryStop) area._foGalleryStop();
          initDesktop();
        }
      } else if (area.dataset.foMobileGallery !== '1') {
        if (area._foGalleryStop) area._foGalleryStop();
        initMobile(0);
      }
    }, 180);
  });

  document.addEventListener('shopify:section:load', function () {
    boundGalleries = [];
    setTimeout(function () {
      boot(true);
    }, 50);
  });
})();
